import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { sendOtpUrl, validateOtp } from '../globals/Services';

export default function Login() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState(null);
  const navigate = useNavigate();

  const sendOtp = async () => {
    if (!mobileNumber) {
      toast.error('Please enter your mobile number');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(sendOtpUrl, {
        mobileNumber: mobileNumber
      });

      if (response.status === 200 || response.data.success) {
        setOtpSent(true);
        toast.success('OTP sent successfully');
      } else {
        toast.error(response.data.message || 'Failed to send OTP');
      }
    } catch (error) {
      console.error('Send OTP error:', error);
      toast.error('Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const enteredOtp = otp.join('');
    if (!enteredOtp || enteredOtp.length !== 6) {
      setOtpError('Please enter a valid 6-digit OTP');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(validateOtp, {
        mobileNumber: mobileNumber,
        otp: enteredOtp
      });

      if (response.status === 200 || response.data.success) {
        let sessionToken = response.data.sessionToken;
        localStorage.setItem('sessionToken', sessionToken);

        const loginTime = new Date().getTime();
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('loginTime', loginTime);

        if (response.data.userProfile["roles"] === "ADMIN") {
          toast.success('Login successful!');
          setTimeout(() => {
          navigate('/');
          },1500);
        } else {
          setOtpError('Someone else is logging in not admin.');
          toast.error('Unauthorized role. Only admin can log in.');
        }
      } else {
        setOtpError('Invalid OTP. Please try again.');
        toast.error(response.data.message || 'Invalid OTP');
      }
    } catch (error) {
      console.error('Login error:', error);
      setOtpError('OTP verification failed. Please try again.');
      toast.error('OTP verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);

    if (e.target.value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
      />

      <div style={{
        backgroundImage: `url('/login_bg.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          maxWidth: 300,
          width: '90%',
          padding: 20,
          borderRadius: 16,          
          backgroundColor: 'rgb(255, 255, 255)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.18)',          
          color: '#1d1d1d',
        }}>
          <h2 
            style={{
                textAlign: 'center',
                fontSize: 20,
                fontWeight: 'bold',
                padding: 8,
              }}>
                Admin Login
            </h2>
          <form onSubmit={handleLogin}>
            <input
              type="tel"
              placeholder="Mobile Number"
              value={mobileNumber}
              required
              onChange={(e) => setMobileNumber(e.target.value)}
              style={{
                width: '100%',
                color: '#000',
                marginTop: 10,
                padding: 8,
                marginBottom: 10,
                borderRadius: 6,
                border: '2px solid grey',
                
              }}
              disabled={otpSent}
            />
            {!otpSent && (
              <button
                type="button"
                onClick={sendOtp}
                style={{
                  width: '99%',
                  height: '35px',
                  fontSize: '16px',
                  textAlign: 'center',
                  margin: '10px 0px 20px 0px',
                  borderRadius: '5px',
                  backgroundColor: '#fff',
                  color: '#000',
                  fontWeight: '500',
                  border: '2px solid grey',
                }}
                disabled={loading}
              >
                {loading ? 'Sending OTP...' : 'Send OTP'}
              </button>
            )}
            {otpSent && (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      type="text"
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      maxLength="1"
                      style={{
                        width: '35px',
                        height: '35px',
                        fontSize: '16px',
                        textAlign: 'center',
                        margin: '10px 0px 20px 0px',
                        borderRadius: '5px',
                        border: '2px solid grey',
                        color: '#000',
                      }}
                    />
                  ))}
                </div>
                {otpError && (
                  <div style={{ color: 'red', fontSize: '12px', paddingBottom: '12px' }}>
                    {otpError}
                  </div>
                )}
                <button
                  type="submit"
                  style={{
                    width: '99%',
                    height: '35px',
                    fontSize: '16px',
                    textAlign: 'center',
                    margin: '10px 0px 20px 0px',
                    borderRadius: '5px',
                    border: '2px solid grey',
                    backgroundColor: '#fff',
                    color: '#000',
                    fontWeight: '500',
                  }}
                  disabled={loading}
                >
                  {loading ? 'Verifying...' : 'Login'}
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
